import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { startRegisterGroupConcernList } from "../../app/actions/groupConcernActions";

const CheckListConcernComponent = ({ groupSelected }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
    const navigate = useNavigate();

  // Selectors - Traemos los datos de Redux
  const { listConcerns, listConcernsGroup } = useSelector((state) => state.catalog);

  //console.log("AA1, listConcernsGroup", listConcernsGroup);

  // Estados locales
  const [filterText, setFilterText] = useState("");
  const [selectedIds, setSelectedIds] = useState(new Set());

  // EFECTO DE SINCRONIZACIÓN: 
  // Cada vez que cambia 'groupSelected' o 'listConcernsGroup' (desde el padre), 
  // reseteamos el buscador y actualizamos los seleccionados.
  useEffect(() => {
    if (groupSelected && listConcernsGroup) {
      setFilterText(""); // Limpia la búsqueda anterior
      const initialIds = new Set(listConcernsGroup.map(item => item.id));
      setSelectedIds(initialIds);
    } else {
      setSelectedIds(new Set());
    }
  }, [groupSelected, listConcernsGroup]);

  // Lógica de Filtrado (Panel Izquierdo: Disponibles)
  const availableFiltered = useMemo(() => {
    const search = filterText.toLowerCase();
    // Filtramos: que coincida con el texto Y que NO esté ya seleccionado
    return listConcerns.filter(item => 
      item.name.toLowerCase().includes(search) && !selectedIds.has(item.id)
    );
  }, [filterText, listConcerns, selectedIds]);

  // Lógica de Seleccionados (Panel Derecho)
  const selectedItems = useMemo(() => {
    return listConcerns.filter(item => selectedIds.has(item.id));
  }, [listConcerns, selectedIds]);

  // Handlers para mover items entre listas
  const toggleSelection = (id) => {
    const newSelection = new Set(selectedIds);
    if (newSelection.has(id)) {
      newSelection.delete(id);
    } else {
      newSelection.add(id);
    }
    setSelectedIds(newSelection);
  };

  /*
  const handleSave = () => {
    if (!groupSelected?.id) {
      return Swal.fire("Error", t("admin.messages.select_group_error"), "error");
    }

    const payload = selectedItems.map(item => ({
      //...item,
      group_id: groupSelected.id, // Usamos el ID del grupo seleccionado actualmente
      concerns:
      //concern_id:item.id,
      //catalogrole_id: item.id,
      //deleted: false
    }));

    console.log("CCCC, payload", payload);

    dispatch(startRegisterGroupConcernList(payload));
    Swal.fire(t("common.success"), t("common.saved_correctly"), "success");
  };*/

  const handleSave = (e) => {
    e.preventDefault();
    //console.log("BBBB, handleSave");
  if (!groupSelected?.id) {
    return Swal.fire("Error", t("admin.messages.select_group_error"), "error");
  }

  // Construimos el objeto único con la estructura que pide el controlador
  const payload = {
    groupConcernsObject: {
      group_id: groupSelected.id,
      // Mapeamos los seleccionados para enviar solo el concern_id
      concerns: selectedItems.map(item => ({
        concern_id: item.id 
      }))
    }
  };

  //console.log("CCCC, enviando este payload:", payload);

  // Enviamos el objeto al dispatch
  dispatch(startRegisterGroupConcernList(payload, navigate));
  
  //Swal.fire(t("common.success"), t("common.saved_correctly"), "success");
};

  // --- RENDERIZADO CONDICIONAL: ESTADO INICIAL ---
  if (!groupSelected) {
    return (
      <div 
        className="d-flex flex-column justify-content-center align-items-center border rounded bg-light" 
        style={{ height: '500px', borderStyle: 'dashed', borderWidth: '2px', color: '#6c757d' }}
      >
        <i className="fa fa-hand-pointer fa-4x mb-3 opacity-50"></i>
        <h4 className="fw-bold">{t("admin.group_concerns.select_to_continue")}</h4>
        <p className="text-center px-4">
          {t("admin.group_concerns.concern_message")}
        </p>
      </div>
    );
  }

  // --- RENDERIZADO PRINCIPAL: CUANDO HAY SELECCIÓN ---
  return (
    <div className="container-fluid p-0">
      {/* Cabecera del panel de edición */}
      <div className="alert alert-info mb-3 d-flex align-items-center">
        <i className="fa fa-edit me-2"></i>
        <span>{t("Editando")}: <strong>{groupSelected.name}</strong></span>
      </div>

      {/* Buscador Superior */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0">
              <i className="fa fa-search text-muted"></i>
            </span>
            <input
              type="text"
              className="form-control border-start-0"
              placeholder={t("Buscar catálogo...")}
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="row g-3">
        {/* Columna 1: Disponibles */}
        <div className="col-md-6">
          <h6 className="fw-bold mb-2">{t("Disponibles")} ({availableFiltered.length})</h6>
          <div className="list-group overflow-auto border" style={{ height: '400px', borderRadius: '8px' }}>
            {availableFiltered.length === 0 && (
              <div className="p-3 text-center text-muted mt-5">{t("No hay resultados")}</div>
            )}
            {availableFiltered.map(item => (
              <div 
                key={item.id} 
                className="list-group-item list-group-item-action d-flex align-items-center gap-2 border-0 border-bottom"
                style={{ cursor: 'pointer' }}
                onClick={() => toggleSelection(item.id)}
              >
                <input
                  type="checkbox"
                  className="form-check-input mt-0"
                  checked={false}
                  readOnly
                />
                <span className="small">{item.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Columna 2: Seleccionados */}
        <div className="col-md-6">
          <h6 className="fw-bold mb-2">{t("Seleccionados")} ({selectedItems.length})</h6>
          <div className="list-group overflow-auto border" style={{ height: '400px', borderRadius: '8px', backgroundColor: '#f8f9fa' }}>
            {selectedItems.length === 0 && (
              <div className="p-3 text-center text-muted mt-5">{t("Nada seleccionado aún")}</div>
            )}
            {selectedItems.map(item => (
              <div 
                key={item.id} 
                className="list-group-item d-flex justify-content-between align-items-center border-0 border-bottom bg-white"
              >
                <span className="small text-success fw-semibold">{item.name}</span>
                <button 
                  className="btn btn-sm btn-outline-danger border-0 rounded-circle" 
                  onClick={() => toggleSelection(item.id)}
                  title={t("Quitar")}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Acciones Finales */}
      <div className="d-flex justify-content-end mt-4 pt-3 border-top">
        <button 
          onClick={handleSave} 
          className="btn btn-primary px-5 shadow-sm"
          disabled={selectedItems.length === 0 && listConcernsGroup.length === 0}
        >
          <i className="fa fa-save me-2"></i>
          {t("buttons.submit")}
        </button>
      </div>
    </div>
  );
};

export default CheckListConcernComponent;
